import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  icon?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看更多",
  icon,
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex items-end justify-between gap-4">
      <div>
        <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          {icon && (
            <span className="flex h-6 w-6 items-center justify-center text-primary-500">
              <i className={`${icon} text-2xl`}></i>
            </span>
          )}
          {title}
        </h2>
        <div className="mt-2 h-1 w-10 rounded-full bg-primary-500"></div>
        {subtitle && (
          <p className="mt-3 text-sm text-foreground-600">{subtitle}</p>
        )}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex shrink-0 items-center gap-1 whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600 cursor-pointer"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-lg"></i>
        </Link>
      )}
    </div>
  );
}